<template>
  <div class="container-book">
    <div class="tab-trim">
      <button @click="changeBook(1)" :class="trim === 1 ? 'active' : ''">Trimestre 1</button>
      <button @click="changeBook(2)" :class="trim === 2 ? 'active' : ''">Trimestre 2</button>
      <button @click="changeBook(3)" :class="trim === 3 ? 'active' : ''">Trimestre 3</button>
      <button @click="goToSpanishVersion" class="btn-spanish-container" v-if="hasMisionPrimaria">
        <img src="../assets/img/mexico.png" class="btn-spanish" />
      </button>
    </div>
    <a class="backBtn" :href="`/#/essential/mission/${missionId}`">
      <img src="/img/back-icon.png" />
    </a>
    <div class="screen-container-book"
      :style="`background-image: url('/img/missions/${$route.params.missionId}-Primaria.png')`">
      <iframe
        :src="`https://storage.googleapis.com/mision-libros-digitales/Alumnos/3Ed/Essential/${missionId}/trim${trim}/MP_SB_NV${missionId}_TRIM${trim}_00_BOOK_PLATAFORMA/index.html`"
        frameborder="0" width="100%" height="100%" style="border: none" id="book" allowfullscreen>
      </iframe>
    </div>
  </div>
</template>

<script>
import Auth from '../services/Auth';
import NProgress from 'nprogress';
import { mapState } from 'vuex';

export default {
  name: 'book',
  async created() {
    NProgress.done();
    this.checkMisionPrimaria();
  },
  data() {
    return {
      trim: 1,
      hasMisionPrimaria: false
    };
  },
  computed: {
    ...mapState({
      essentials: state => state.session.currentGrade.data.essentials
    }),
    missionId() {
      return this.$route.params.missionId;
    }
  },
  methods: {
    changeBook(trim) {
      this.trim = trim;
    },
    logout() {
      Auth.logout();
    },
    goToMission() {
      this.$router.push(`/mission/${this.missionId}`);
    },
    goToSpanishVersion() {
      this.$router.push({ path: `/mission/${this.missionId}/libro` });
    },
    checkMisionPrimaria() {
      if (this.essentials) {
        this.hasMisionPrimaria = this.essentials.some(item => item.includes('Misión Primaria'));
        console.log('Has Misión Primaria:', this.hasMisionPrimaria);
      }
    }
  }
};
</script>

<style lang="scss">
.container-book {
  .tab-trim {
    display: flex;
    position: absolute;
    padding: 9px;
    margin: 13px 0 0 0;
    border-bottom: 2px solid #98d3fd;
    width: 100%;

    button {
      color: #fff;
      font-family: Montserrat;
      font-weight: 800;
      font-size: 21px;
      padding: 7px 16px;
      background: #040403c9;
      margin: 0 5px;
      text-shadow: 1.5px 1px #070704a1;
      border: 1px solid white;
    }

    button:hover {
      background: #98d3fd;
    }

    .active {
      background: #98d3fd;
    }

    .btn-spanish-container {
      background: none;
      border: none;
      padding: 0;
      margin-left: 20px;
    }

    .btn-spanish-container:hover {
      background: none;
    }

    .btn-spanish {
      width: 65px;
      height: auto;
    }
  }
}

.selectTrim {
  position: absolute;
  left: 7px;
  width: 139px;
  height: auto;
  top: 9px;
  z-index: 9999;
  background: #6b94b1;
  color: #fff;
  border: 0;
  border-radius: 5px;
  /* padding-left: 7px; */
  text-align: center;
  padding: 9px 0;
}

.selectTrim:checked {
  border-radius: 0;
}

select option {
  margin: 40px;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  border-radius: 5px;
}

select:focus+.focus {
  position: absolute;
  top: -1px;
  left: -1px;
  right: -1px;
  bottom: -1px;
  border: 2px solid var(--select-focus);
  border-radius: 60px;
}

#app #fbToolBar {
  background: #fff;
}

.screen-container-book {
  width: 100vw;
  height: 100vh;

  #book {
    width: 100%;
    height: 100%;
    height: calc(100vh - 50px);
    margin-top: 50px;
  }
}

.backgroundDesk {
  // background-image: url('/img/new/backgroundLoginDesk.png');
  height: 100vh;
}

.backgroundTable {
  // background-image: url('/img/new/containerLogin.png'); 
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center center;
  padding: 9.5vh 0;
}

.spacecraft-container-glass {
  min-width: 100%;
  min-height: 100vh;
  max-height: 100vh;
  padding-top: 1rem !important;
  padding-bottom: 0rem;
  background-position: 50% 50%;
  background-image: url('/img/backgroundSpacecraft.png');
  background-size: cover;
  display: flex;
  align-items: center;
}

.mission-screen {
  border-style: solid;
  border-color: #17202A;
  border-width: 20px;
  border-radius: 50px;
  min-width: 93%;
  min-height: 95vh;
  margin: auto;
  padding-top: 0;
  padding-bottom: 0rem;
  padding-left: 2rem;
  background-image: url('/img/glass.png');
  background-size: cover;
}

.bookContainer {
  height: 81vh;
  min-height: 50vh;
  width: 100%;
}
</style>